"use strict";

angular.module("autofocus")
.directive("autofocus", function($timeout) {
    return {
        restrict: "A",
        scope: {
            select: "<?autofocusSelect"
        },
        link: function(scope, element) {
            $timeout(function() {
                element[0].focus();
                if (scope.select) {
                    element[0].select();
                }
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/autofocus/autofocus.directive.js
// module id = 336
// module chunks = 0